const productService1 = {
    number: "1/2",
    question: "Product/Service",
    description: `List your products/services`
}

const combine = {
    number: "2/2",
    question: "Product/Service",
    description: "If there were multiple, sum them up in a sentence."
}

export const questions = {
    productService1: productService1,
    combine: combine,
}

const impactService1Video = {
    url: "https://www.dropbox.com/scl/fi/0fy2cnsw1hyfshijav42t/14-The-Features.mp4?rlkey=350nfqyoh97qcncs5dreugk6i&raw=1"
}

const combineVideo = {
    url: "https://www.dropbox.com/scl/fi/jhbmxw2ib77b5gp0z539g/15-Bringing-them-together.mp4?rlkey=0eanhm11ml92tslgl84zzmr49&raw=1"
}

export const videos = {
    impactService1Video: impactService1Video,
    combineVideo: combineVideo,
}